import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CoreUIToastV2Service, CoreUIToastDirection } from '../../services/toast.service';
import { OrgSdk } from 'lib-klab-sdks';
import { DepartmentsPort } from '../../../app/ports/organization/departments.port';
import { mapSDKDepartmentsToOptions } from '../../mappers/organization/department.mapper';
import { mapOrganizationErrorToMessage } from '../../utils/organization-error.mapper';
import { Option } from '../../../domain/models/shared/option.model';

@Injectable({ providedIn: 'root' })
export class DepartmentsPortAdapter implements DepartmentsPort {
    private readonly departmentsApi = inject(OrgSdk.DepartmentsService);
    private readonly toast = inject(CoreUIToastV2Service, { optional: true });

    searchDepartments(q: string): Observable<Option[]> {
        const term = String(q ?? '').trim();
        if (term.length < 2) return of([]);

        return this.departmentsApi.searchDepartments(term).pipe(
            map(mapSDKDepartmentsToOptions),
            catchError((err) => {
                if (this.toast) {
                    this.toast.show({
                        data: {
                            title: 'Error',
                            msg: mapOrganizationErrorToMessage(err),
                            direction: CoreUIToastDirection.topCenter,
                            autoClose: true,
                        },
                    });
                }
                return of([]);
            }),
        );
    }

    searchDepartmentsWithSearchAll(): Observable<Option[]> {
        return this.departmentsApi.searchDepartments(undefined, true).pipe(
            map(mapSDKDepartmentsToOptions),
            catchError((err) => {
                if (this.toast) {
                    this.toast.show({
                        data: {
                            title: 'Error',
                            msg: mapOrganizationErrorToMessage(err),
                            direction: CoreUIToastDirection.topCenter,
                            autoClose: true,
                        },
                    });
                }
                return of([]);
            }),
        );
    }

    getDepartments(): Observable<Option[]> {
        return this.departmentsApi.searchDepartments().pipe(
            map(mapSDKDepartmentsToOptions),
            catchError((err) => {
                if (this.toast) {
                    this.toast.show({
                        data: {
                            title: 'Error',
                            msg: mapOrganizationErrorToMessage(err),
                            direction: CoreUIToastDirection.topCenter,
                            autoClose: true,
                        },
                    });
                }
                return of([]);
            }),
        );
    }
}
